import React from "react";
import { Grid2 as Grid , Typography, Divider } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { AgreementsAutocomplete, StoresAutocomplete } from "@shared/components/AutocompleteFields";

export const AdditionalFields = React.memo(() => {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Divider />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Typography style={{ fontSize: 18, color: "primary.main" }}>
          {translate("v1/user_admin.titles.additional_information")}
        </Typography>
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="vandi_customer_id"
          label={translate("v1/user_admin.fields.vandi_customer_id")}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <AgreementsAutocomplete
          name="active_agreement"
          label={translate("v1/user_admin.fields.active_agreement")}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <StoresAutocomplete
          name="user_pdv"
          label={translate("v1/user_admin.fields.user_pdv")}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <AgreementsAutocomplete
          name="agreement_staff"
          multiple
          label={translate("v1/user_admin.fields.agreement_staff")}
        />
      </Grid>
    </Grid>
  );
});
